import { render } from "./TheVault.vue?vue&type=template&id=37302a48&scoped=true"
import script from "./TheVault.vue?vue&type=script&lang=js"
export * from "./TheVault.vue?vue&type=script&lang=js"

import "./TheVault.vue?vue&type=style&index=0&id=37302a48&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37302a48"]])

export default __exports__